import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import {
  InlineIconSuccess,
  InlineIconFailure,
} from '#components/Elements/SVGIcon/TimelineStatusIcon';
import styles from './PasswordHints.scss';

export const passwordRequirements = [
  {
    key: 'length',
    message: 'Between 12 and 64 characters',
    test: (value) => value?.length >= 12 && value?.length <= 64,
  },
  {
    key: 'number',
    message: 'At least one number',
    test: (value) => /\d/.test(value),
  },
  {
    key: 'special',
    message: 'At least one special character',
    test: (value) => /[^a-zA-Z0-9]/.test(value),
  },
  {
    key: 'upper',
    message: 'At least one uppercase and lowercase letter',
    test: (value) => /[a-z]/.test(value) && /[A-Z]/.test(value),
  },
];

export const passwordsMatch = (password, passwordConfirm) =>
  password === passwordConfirm;

export const passwordRequirementsMet = (password) =>
  passwordRequirements.every((requirement) => requirement.test(password));

export const PasswordHints = ({ formProps }) => {
  const { password, password_confirm: passwordConfirm } = formProps.values;

  return (
    <div className={styles.passwordHints}>
      <ul>
        {passwordRequirements.map((requirement) => {
          const IconComponent = requirement.test(password)
            ? InlineIconSuccess
            : InlineIconFailure;

          return (
            <li key={requirement.key}>
              {!!password && (
                <span
                  className={classNames({
                    [styles.successIcon]: requirement.test(password),
                    [styles.failureIcon]: !requirement.test(password),
                  })}
                >
                  <IconComponent />
                </span>
              )}
              {requirement.message}
            </li>
          );
        })}
        <li>
          {!!password &&
            (passwordsMatch(password, passwordConfirm) ? (
              <span className={styles.successIcon}>
                <InlineIconSuccess />
              </span>
            ) : (
              <span className={styles.failureIcon}>
                <InlineIconFailure />
              </span>
            ))}
          <FormattedMessage defaultMessage="Entered passwords match" />
        </li>
      </ul>
    </div>
  );
};
